var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 13,
    viewBox: "0 0 24 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6269 0.45956C17.0174 0.0690359 17.6506 0.0690359 18.0411 0.45956L23.3744 5.79289C23.7649 6.18342 23.7649 6.81658 23.3744 7.20711L18.0411 12.5404C17.6506 12.931 17.0174 12.931 16.6269 12.5404C16.2364 12.1499 16.2364 11.5168 16.6269 11.1262L20.2531 7.5L1.33398 7.5C0.7817 7.5 0.333984 7.05229 0.333984 6.5C0.333984 5.94772 0.7817 5.5 1.33398 5.5L20.2531 5.5L16.6269 1.87377C16.2364 1.48325 16.2364 0.850084 16.6269 0.45956Z",
    fill: "#00322E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.56b5e83a1eefb9ee2748c0d4468b2076.svg";
export { ForwardRef as ReactComponent };